
import { useTranslation } from 'react-i18next';
import { CheckCircle } from 'lucide-react';

const CertificateShowcase = () => {
  const { t } = useTranslation();

  const highlights = [
    t('showcase.point1'),
    t('showcase.point2'),
    t('showcase.point3'),
    t('showcase.point4'),
  ];

  return (
    <section className="relative py-0 overflow-hidden">
      {/* Full-width image with overlay */}
      <div className="relative w-full h-[520px]">
        <img
          src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/965fdf337a844e7f3caa1ef13a6fc849.jpeg"
          alt="IQ CERT GMP, HACCP, ISO sertifika belgeleri - uluslararası geçerli sertifikalar"
          title="IQ CERT Uluslararası Sertifika Belgeleri"
          className="w-full h-full object-cover object-center"
        />
        {/* Dark gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/40 to-transparent" />

        {/* Content on top of image */}
        <div className="absolute inset-0 flex items-center">
          <div className="container mx-auto px-4">
            <div className="max-w-xl">
              {/* Badge */}
              <span className="inline-block px-4 py-1.5 bg-teal-500/90 text-white rounded-full text-sm font-semibold mb-5 tracking-wide uppercase">
                {t('showcase.badge')}
              </span>

              <h2 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight">
                {t('showcase.title')}
              </h2>
              <p className="text-gray-200 text-lg mb-8 leading-relaxed">
                {t('showcase.description')}
              </p>

              <ul className="space-y-3">
                {highlights.map((point, i) => (
                  <li key={i} className="flex items-center gap-3 text-white">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <CheckCircle className="w-5 h-5 text-teal-400" />
                    </div>
                    <span className="text-base">{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Decorative right-side accent */}
        <div className="absolute right-0 top-0 h-full w-1 bg-teal-500 opacity-80" />
        <div className="absolute right-1 top-0 h-full w-0.5 bg-teal-300 opacity-40" />
      </div>

      {/* Bottom decorative bar */}
      <div className="h-1.5 w-full bg-gradient-to-r from-teal-600 via-teal-400 to-teal-600" />
    </section>
  );
};

export default CertificateShowcase;
